import { ButtonProps } from "@mui/material";
import classNames from "classnames";
import { AppButton } from "../../../../shared/components/AppButton";
import { AlertIcon } from "../../../../shared/icons/AlertIcon";
import styles from "./styles.module.css";

interface Props extends ButtonProps {
  title: string;
  isDisabled?: boolean;
  className?: string;
}

export const AlertButton = ({
  title,
  isDisabled,
  className,
  ...rest
}: Props) => {
  const cls = classNames(styles.button, styles["alert-button"], className);

  return (
    <AppButton
      disabled={isDisabled}
      buttonType={"text"}
      icon={<AlertIcon />}
      className={cls}
      {...rest}
    >
      {title}
    </AppButton>
  );
};
